import Footer from "../components/footer/Footer";
import Header from "../components/header/Header";
import Contents from "../components/pages/patentInfo/Content";

const PatentInfo = () => {
    return (
    <>
        <Header />
        <Contents />
        <Footer />
    </>
    );
};

export default PatentInfo;
